import StyledSlider from '@e3dc-react/shell/Elements/Slider/StyledSlider'
import React from 'react'

const STEP = 1

export interface ChargingSliderProps {
  value: number
  min: number
  max: number
  onChange: (value: number) => void
  markerInPercentage?: number
}

/**
 * Slider component to select the minimum level of charge of the vehicle and display max charging value of the vehicle as marker
 */
const ChargingSlider: React.FC<ChargingSliderProps> = ({ value, min, max, onChange, markerInPercentage }) => {
  const handleChange = (event: Event, newValue: number | number[]): void => {
    onChange(newValue as number)
  }

  return (
    <StyledSlider
      min={min}
      max={max}
      step={STEP}
      value={value}
      onChange={handleChange}
      marks={markerInPercentage ? [{ value: markerInPercentage, label: '' }] : undefined}
    />
  )
}

export default ChargingSlider
